// extracted by mini-css-extract-plugin
export default {"icon":"icon_icon__B9aK6","xs":"icon_xs__p0ftP","sm":"icon_sm__0GEc2","md":"icon_md__xfe6c","lg":"icon_lg__jO7k-","xl":"icon_xl__1eIQs"};